var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3514 18.7C23.65 18.7 24.7028 17.6479 24.7028 16.35C24.7028 15.0521 23.65 14 22.3514 14C21.0528 14 20 15.0521 20 16.35C20 17.6479 21.0528 18.7 22.3514 18.7Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2829 14.2392C21.2562 14.2392 23.4074 11.563 23.6119 8.01877C23.6204 7.86134 23.6247 7.70818 23.6247 7.55075C23.6247 3.36408 21.0134 0.777191 16.8346 0.777191H0L3.17779 4.29586H16.6344C18.8452 4.29586 19.9613 5.49571 19.9613 7.55075C19.9613 9.57601 18.8452 10.8056 16.6344 10.8056H15.0157L18.0316 14.2392H18.2829Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7759 21H16.7366L4.57073 6.61897H9.60578L21.7759 21Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.21926 21H3.6847C3.44615 21 3.25021 20.766 3.25021 20.4809V17.4558C3.25021 16.9963 3.71878 16.7623 3.9914 17.0899L6.52597 20.115C6.80285 20.4426 6.6069 21 6.21926 21Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRWhite);
export default __webpack_public_path__ + "static/media/R-white.00fbf2602527b585ea75a96b2de3684a.svg";
export { ForwardRef as ReactComponent };